import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Persisted view-mode + session ordering for the cabinet Performance Reviews
 * list, mirroring the CRM list stores (CLAUDE.md §2.3). */
export type ReviewsViewMode = 'table' | 'list' | 'cards' | 'grouped';

interface ReviewsUiState {
  view: ReviewsViewMode;
  setView: (view: ReviewsViewMode) => void;
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useReviewsUi = create<ReviewsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'cabinet.reviews:ui',
      version: 1, // v1: default flipped cards → table; drop stale persisted view.
      migrate: () => ({}) as Partial<ReviewsUiState>,
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
